import { useEffect, useState } from "react";
import { db } from "../firebase"; // Make sure this imports your Firebase config
import { doc, getDoc, getDocs, collection } from "firebase/firestore";
import PackagesSearch from "../components/packages/PackagesSearch"; // Import the search component

const Packages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchPackagesAndDestinations = async () => {
      try {
        // Fetch all packages from the Firestore collection
        const packagesSnapshot = await getDocs(collection(db, "packages"));
        const packagesData = [];

        // Loop through all packages and fetch their respective destination data
        for (const docSnapshot of packagesSnapshot.docs) {
          const packageData = { id: docSnapshot.id, ...docSnapshot.data() };

          // Fetch the corresponding destination data for each package using destinationId
          let destinationData = null;
          if (packageData.destinationId) {
            const destinationRef = doc(
              db,
              "destinations",
              packageData.destinationId
            );
            const destinationSnap = await getDoc(destinationRef);
            if (destinationSnap.exists()) {
              destinationData = {
                id: destinationSnap.id,
                ...destinationSnap.data(),
              };
            }
          }

          // Combine the package and destination data into one object
          packagesData.push({
            ...packageData,
            destination: destinationData,
          });
        }

        // Update state with the combined data
        if (packagesData.length === 0) {
          setNotFound(true);
        }
        setPackages(packagesData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setNotFound(true);
        setLoading(false);
      }
    };

    fetchPackagesAndDestinations();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (notFound) {
    return <div>Packages not found</div>;
  }

  return (
    <div className="packages-home">
      <PackagesSearch packages={packages} setPackages={setPackages} />
    </div>
  );
};

export default Packages;
